import {FetchError} from '@frontrow/console/src/open-api/middleware/error'
import {firstResponseApiError} from '@frontrow/console/src/entities/models/api-error'

export type SyncResultT =
  | {
      tag: 'SyncResultSuccess'
      contents: SyncResultSuccessT
    }
  | {
      tag: 'SyncResultFailure'
      contents: SyncResultFailureT
    }

export type SyncResultSuccessT = {
  schoolIdpId: number
  schoolName: string
  syncTime: number
  unchangedCounts: SnapshotCountsT
  updatedCounts: SnapshotCountsT
  deletedCounts: SnapshotCountsT
  addedCounts: SnapshotCountsT
  failedItems: FailedLogsT
}

export type SnapshotCountsT = {
  courseMembershipCount: number
  studentCount: number
  teacherCount: number
  courseCount: number
}

type FailedLogsT = {
  failedStudents: Array<LogPairT>
  failedTeachers: Array<LogPairT>
  failedCourseMemberships: Array<LogPairT>
  failedCourses: Array<LogPairT>
}

export type SyncResultFailureT = {
  schoolIdpId: number
  failure: LogMessageT
}

export type LogPairT = {
  idpId: string
  logMessage: LogMessageT
  courseId?: string
  studentId?: string
}

type LogMessageT = {
  severity: 'error' | 'warning'
  message: string
}

export type IsDryRun = 'dry-run' | 'real-run'

export type CsvFileErrorT = {
  csvFileName: string
  errors: Array<CsvErrorT>
}

type CsvErrorT = {
  message: string
  rowNumber?: number
  rowNumberFirstSeen?: number
}

export type RosteringFilesT = {
  teachersCsv: File
  studentsCsv: File
  coursesCsv: File
  enrollmentsCsv: File
}

/**
 * The per-file CSV errors the roster endpoints return as `errors[0]` of a 4xx
 * body. Any other failure becomes a single entry holding its message.
 */
export function csvFileErrorsFromError(err: unknown): Array<CsvFileErrorT> {
  if (err instanceof FetchError) {
    const errors = (err.response.json as {errors?: unknown} | undefined)?.errors
    if (Array.isArray(errors) && Array.isArray(errors[0])) {
      return errors[0] as Array<CsvFileErrorT>
    }
  }
  return [
    {
      csvFileName: 'Request',
      errors: [{message: firstResponseApiError(err, 'Unknown error occurred').message}]
    }
  ]
}
